import { baseURL } from '@utils/data-fetching/utils';
import type { RecruiterCallVoiceTokenResponse } from '@type/recruiter-call';

/**
 * Mint a short-lived Twilio Voice Access Token for the logged-in recruiter.
 * Not an SWR hook — voice tokens are short-lived and should be re-minted
 * per softphone session, not cached.
 *
 * The endpoint requires an authenticated session (bestjobs cookie); no
 * request body is needed. Uses the same `baseURL` (`api.bestjobs.dev` in
 * dev, `api.bestjobs.eu` in prod) that `useSwrApi` prepends for every
 * other API call — a relative fetch would hit the frontend origin.
 */
export const fetchRecruiterCallVoiceToken = async (): Promise<RecruiterCallVoiceTokenResponse> => {
  const response = await fetch(`${baseURL}/v3/recruiter-calls/voice-token`, {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch RecruiterCall voice token: HTTP ${response.status}`);
  }
  return (await response.json()) as RecruiterCallVoiceTokenResponse;
};
